import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { AdditionalComponent, UiComponent } from 'components';
import { AdditionalQuery } from 'queries';
import { useIsMobile, usePageOption } from 'hooks';
import { EVENT_MENU_URL } from 'data/menu';
import { SearchAdditionalFilterType } from 'types';

function DesktopList() {
  const pageState = usePageOption();
  const [filter, setFilter] = useState<SearchAdditionalFilterType>({});

  const { data } = AdditionalQuery.useGetAll({
    page: pageState.pageOption.page,
    size: pageState.pageOption.size,
    ...filter,
  });

  return (
    <AdditionalComponent.List
      toolbar={
        <AdditionalComponent.Filter filter={filter} handleFilter={setFilter} />
      }
      {...pageState}
      totalPage={data?.totalPages}
      data={data?.data || []}
    />
  );
}

function MobileList() {
  const navigate = useNavigate();
  const [filter, setFilter] = useState<SearchAdditionalFilterType>({});
  const { data, hasNextPage, isFetchingNextPage, fetchNextPage, isLoading } =
    AdditionalQuery.useGetInfinite(filter);

  return (
    <UiComponent.MobileTitleList
      pageTitle={
        <UiComponent.PageTitle>추가 정보 템플릿 목록</UiComponent.PageTitle>
      }
      items={data ?? []}
      isLoading={isLoading}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      fetchNextPage={fetchNextPage}
      onSelect={(id: number) =>
        navigate(`${EVENT_MENU_URL['추가정보 템플릿']}/${id}`)
      }
      onSearch={(title) => setFilter({ title })}
      emptyText="추가정보 템플릿이 없습니다"
    />
  );
}

function List() {
  const isMobile = useIsMobile();

  if (isMobile) return <MobileList />;

  return (
    <>
      <UiComponent.PageTitle>추가 정보 템플릿 목록</UiComponent.PageTitle>
      <DesktopList />
    </>
  );
}

export default List;
